
    var data;

    if (typeof window['__gdata_wuwsb'] === 'undefined') {
        data = window['__gdata_wuwsb'] = {};
    } else {
        data = window['__gdata_wuwsb'];
    }


    var DEFINED = '__defined' + (new Date()).getTime(),
        undefinedVar;

    // 接口：get
    var get = exports.get = function(key){
        var keyValue;
        if(key) {
            var tmpValue = data[key];
            if(tmpValue !== undefinedVar && tmpValue !== DEFINED){
                keyValue = tmpValue;
            }
        }
        return keyValue;
    };

    // 接口：set
    var set = exports.set = function(key, value){
        // 未 define 的，就直接抛错误
        if(data[key] === undefinedVar){
            require('@alife/alpha-util/log').info(key + ' is undefined!(Gdata)');
        } else {
            data[key] = value;
        }
    };

    // 接口：define
    var define = exports.define = function(key, value){
        // 已 define的，就直接抛错误
        if(data[key] !== undefinedVar){
            require('@alife/alpha-util/log').info(key + ' is defined!(Gdata)');
        } else {
            data[key] = (value !== undefinedVar ? value : DEFINED);
        }
    };
